<mat-dialog-content style="max-height: 600px;height: fit-content;width: 1500px;">

<textarea rows = "5" cols = "60" name = "Diagnosis" [(ngModel)]= "wk_Data" class="appointment-form-field" style="font-weight: bold;font-size: 02vw;height: 600px;width: 1400px;" disabled="true"> Enter details here... </textarea><br>

</mat-dialog-content>
